import { Transition } from '@uirouter/angularjs';
import { Action } from './common/actions/core/action';

export class StateTransitionStartedAction implements Action {
  constructor(public transition: Transition) {}
}

export class StateTransitionSucceedAction implements Action {
  constructor(public transition: Transition) {}
}



// WEBPACK FOOTER //
// src/app/app.action.ts